import { Backdrop, CircularProgress, Paper, Typography } from '@mui/material';
import { HeicConversionProgress } from './useHeicConversion';

const conversionMessage = ({ photoNumber, total }: HeicConversionProgress): string =>
  total > 1 ? `Converting HEIC photo ${photoNumber} of ${total}…` : 'Converting HEIC photo…';

export const HeicConversionBackdrop = ({ conversion }: { conversion?: HeicConversionProgress }) => (
  <Backdrop
    open={conversion !== undefined}
    sx={{ zIndex: theme => theme.zIndex.modal + 1 }}
    data-testid='heic-converting'
  >
    <Paper sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 3, py: 2, borderRadius: '12px' }}>
      <CircularProgress size={20} />
      <Typography variant='body2'>{conversion && conversionMessage(conversion)}</Typography>
    </Paper>
  </Backdrop>
);
